import React from 'react'

function DeliveryStatus(invoice_item) {
  const is_delivery = invoice_item.is_delivery;
  const is_transfer = invoice_item.is_tranfer;
  const status = invoice_item.user_product && invoice_item.user_product.status;
  return(
    <React.Fragment>
      <center>
        {is_delivery && status != "PENDING_TRANSFER" && <span className="badge badge-primary">Đã Khởi Tạo</span>}
        {is_delivery && is_transfer && status == "PENDING_TRANSFER" && <span className="badge badge-dark">PENDING TRANSFER</span>}
        {!is_delivery && <span className="badge badge-secondary">Chưa Khởi Tạo</span>}
      </center>
    </React.Fragment>
  )
}
export default DeliveryStatus;